import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Eye",
  "use": "Eye-usage",
  "viewBox": "0 0 22 15",
  "content": "<symbol viewBox=\"0 0 22 15\" id=\"Eye\"><path d=\"M11,0C6,0,1.7,3.1,0,7.5C1.7,11.9,6,15,11,15s9.3-3.1,11-7.5C20.3,3.1,16,0,11,0z M11,12.5c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S13.8,12.5,11,12.5z M11,4.5c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S12.7,4.5,11,4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol